import { cn } from "@/lib/utils/cn";

interface SpinnerProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  label?: string;
}

const sizeMap = {
  xs: "w-3 h-3 border",
  sm: "w-4 h-4 border-2",
  md: "w-6 h-6 border-2",
  lg: "w-8 h-8 border-2",
  xl: "w-12 h-12 border-[3px]",
};

export function Spinner({ size = "md", className, label }: SpinnerProps) {
  return (
    <div role="status" className="inline-flex items-center gap-2">
      <div
        className={cn(
          "rounded-full border-border border-t-brand animate-spin",
          sizeMap[size],
          className
        )}
        aria-hidden="true"
      />
      {label && <span className="text-sm text-text-muted">{label}</span>}
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export function PageSpinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-3">
      <Spinner size="lg" />
      {label && <p className="text-sm text-text-muted">{label}</p>}
    </div>
  );
}
